import { type ReactNode } from 'react'

export interface FirmDashboardJobsViewerProps {
  children: ReactNode
}

export function FirmDashboardJobsViewer({
  children,
}: FirmDashboardJobsViewerProps) {
  return <div>{children}</div>
}
